
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";

import { environment } from "../environments/environment";
import { AuthService } from "./auth.service";
import { Router } from "@angular/router";
import { Rekbot } from "../models/rekbot.model";
import { RekbotSettings } from "../models/rekbot-settings.model";
import { EmailConfig } from "../models/email-config.model";

@Injectable({
    providedIn: 'root'
})

export class EmailConfigListService {

    public emailList: string[] = [
    ];

    public currentEmail: EmailConfig = {} as EmailConfig;
    public currentRekbotId: number = 0;

    constructor(
        private http: HttpClient,
        private authService: AuthService,
        private router: Router
    ) {

        console.log("construct", this.emailList)
    }

    setCurrentEmail(email: EmailConfig) {
        this.currentEmail = email;
    }

    setCurrentRekbotId(rekbotId: number) {
        this.currentRekbotId = rekbotId;
    }

    getCurrentRekbotId() {
        return this.currentRekbotId;
    }

    getCurrentEmail() {
        return this.currentEmail;
    }

    addEmail(rekbotId: number, emailConfig: EmailConfig) {
        const endpoint = environment.apiUrl + "/api/rekbots/" + rekbotId + '/email-config-list';
        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()
        return this.http.post(
            endpoint, 
            emailConfig,
            {
                headers: new HttpHeaders().set("Authorization", bearerToken)
            })
    }

    updateEmail(rekbotId: number, emailConfig: EmailConfig) {

        const endpoint = environment.apiUrl + "/api/rekbots/" + rekbotId + '/email-config-list/' + emailConfig.id;
        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()
        return this.http.put(
            endpoint, 
            emailConfig,
            {
                headers: new HttpHeaders().set("Authorization", bearerToken)
            })
    }


    removeEmail(rekbotId: number, emailConfig: EmailConfig) {

        const endpoint = environment.apiUrl + "/api/rekbots/" + rekbotId + '/email-config-list/' + emailConfig.id;

        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()
        return this.http.delete(endpoint, {
                headers: new HttpHeaders().set("Authorization", bearerToken)
            }
        );
    }

    fetchEmails(rekbotId:number) {
        const endpoint = environment.apiUrl + "/api/rekbots/" + rekbotId + '/email-config-list';
        if(this.authService.getToken().length == 0) {
            this.router.navigate(['/']);
        }
        const bearerToken = "Bearer " + this.authService.getToken()
        return this.http.get(endpoint, {headers: new HttpHeaders().set("Authorization", bearerToken)})
    }


}